module.exports = __webpack_public_path__ + "img/Infinity8_Express.076acbbb.png";